import { getRequest } from '../common/utils'

export function getByCriteria(criteria) {
    return getRequest(`/province`, criteria)
}